
export const roles = {
  label: "Roles",
  type: "array",
  items: {
    type: "string",
    default: "",
  },
  default: [],
  widget: "tags",
};

export const keyId = {
  label: "API Key ID",
  type: "string",
};

// What the key is for, in the owner's words. keyId is opaque and the secret is
// shown once, so this is the only thing that tells two keys apart in the list.
// Stored by auth-repoflow with the rest of the key — datum keeps no key rows.
export const description = {
  label: "Description",
  type: "string",
};

export const keySecret = {
  type: "string",
};

